import * as ACTION_TYPES from '../types';

let initialState = {
  contactList: [],
  contact: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CONTACTS:
        return {...state, contactList: action.data };

      case ACTION_TYPES.DELETE_CONTACT:
        let newList = state.contactList.filter(contact => contact._id !== action.id);
        return {...state, contactList: newList };

      case ACTION_TYPES.GET_CONTACT_BY_ID:
        return {...state, contact: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CONTACT:
        return {...state, contactList: []};

      default:
        return state;
    }
  };